import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body" }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "col-lg-12" }
const _hoisted_4 = {
  key: 0,
  class: "form-row"
}
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = { class: "form-row" }
const _hoisted_7 = { class: "col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DBEdit = _resolveComponent("DBEdit")!
  const _component_DBForm = _resolveComponent("DBForm")!

  return (_openBlock(), _createBlock(_component_DBForm, {
    store: _ctx.store,
    config: _ctx.settings,
    data: _ctx.data,
    readonlyForm: _ctx.readonly,
    watchChange: true,
    ref: "form"
  }, {
    default: _withCtx((form) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DBEdit, {
              form: form,
              field: "signalType"
            }, null, 8, ["form"])
          ])
        ]),
        (_ctx.store.data.signalType === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_DBEdit, {
                  form: form,
                  field: "customDate"
                }, null, 8, ["form"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DBEdit, {
              form: form,
              field: "description",
              rows: "5"
            }, null, 8, ["form"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["store", "config", "data", "readonlyForm"]))
}